export default "__VITE_ASSET__eea358af__"